import { Route, Routes, useParams } from 'react-router-dom'
import ProductionRouteCreate from './production-route-create'
import { usePermissions } from '@/shared/hooks/usePermissions'
import { useEffect } from 'react'
import { useAppState } from '@/app/hooks/useAppState'

export default function ProductionRoutes() {
  const { checkPermission } = usePermissions()
  const canCreateProductionRoute = checkPermission('productionRoute', 'create')

  const installationId = useParams<{ installationId: string }>().installationId!
  const { setSelectedInstallationId } = useAppState()

  useEffect(() => {
    setSelectedInstallationId(installationId)
  }, [installationId, setSelectedInstallationId])

  const localStorageProductionRouteKey = 'production-route-creation-state'

  return (
    <>
      <Routes>
        {canCreateProductionRoute && (
          <Route path="/new">
            <Route
              index
              path="*"
              element={<ProductionRouteCreate localStorageKey={localStorageProductionRouteKey} />}
            />
          </Route>
        )}
      </Routes>
    </>
  )
}
